<mat-nav-list>
  @for (item of navigationItems; track item.route) {
  @if (item.children) {
  <mat-list-item class="parent-item" [class.active-parent]="hasActiveChild(item)" (click)="toggleExpansion(item)">
    <mat-icon matListItemIcon>{{item.icon}}</mat-icon>
    <span matListItemTitle>{{item.label}}</span>
    <div matListItemMeta>
      <mat-icon>
        {{item.expanded ? 'expand_less' : 'expand_more'}}
      </mat-icon>
    </div>
  </mat-list-item>

  @if (item.expanded) {
  <div class="children-container">
    @for (child of item.children; track child.route) {
    <mat-list-item [routerLink]="child.route" [class.active-route]="isActive(child.route)" class="child-item">
      <mat-icon matListItemIcon>{{child.icon}}</mat-icon>
      <span matListItemTitle>{{child.label}}</span>
    </mat-list-item>
    }

  </div>
  }

  } @else {
  <mat-list-item [routerLink]="item.route" [class.active-route]="isActive(item.route)" class="single-item">
    <mat-icon matListItemIcon>{{item.icon}}</mat-icon>
    <span matListItemTitle>{{item.label}}</span>
  </mat-list-item>
  }
  }
  <mat-list-item (click)="logout()" class="single-item">
    <mat-icon matListItemIcon>logout</mat-icon>
    <span matListItemTitle>Logout</span>
  </mat-list-item>
</mat-nav-list>